import { TagInfo } from '@/interfaces/tag';
import request from '@/utils/request';

export const getTags = () => {
  return request<TagInfo[]>({ url: '/v1/customer-tag/list', method: 'POST' });
};

export const createTag = (data: Partial<TagInfo>) => {
  return request<{ list: TagInfo[] }>({ url: '/v1/customer-tag/create', method: 'POST', data });
};

export const updateTag = (data: Partial<TagInfo>) => {
  return request<{ list: TagInfo[] }>({ url: '/v1/customer-tag/update', method: 'PUT', data });
};

export const deleteTag = (id: number) => {
  return request({ url: '/v1/customer-tag/del', method: 'DELETE', params: { id } });
};

export const createAndBindCustomerTag = (data: {
  customerId: string;
  name: string;
  color: string;
}) => {
  return request({ url: '/v1/customer-tag/create-bind', method: 'POST', data });
};
